import React from "react"
import {FieldTableCellProps, getTableCellStyle} from "../../../../render/table/table-cell"
import FieldTimeReportIsBillable_Editable from "./editable"
import ApiTimeReport from "../../../../../gd/api/time-reports/time-report"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"

// const debug = "FieldTimeReportIsBillable_TableCell"
const debug = false

export default function FieldTimeReportIsBillable_TableCell(props: FieldTableCellProps): React.ReactElement {
    const timeReport    = props.listItem.timeReport
    const canEdit       = !props.manager.isReadOnly && props.field.canEdit(timeReport)

    const onChange = async (isBillable: boolean) => {
        debug && console.log(debug, 'onChange', isBillable)

        timeReport.isBillable = isBillable
        await ApiTimeReport.update(timeReport.id, {
            isBillable: isBillable
        }).promise()
        props.listItem.updateLastUpdateTime()
        FieldProto_updateView(props.manager, props.field)
    }

    debug && console.log(debug, 'render', canEdit, timeReport.isBillable)

    return (
        <div className  = "cell-flex p-h-0"
             style      = {getTableCellStyle(props)}
        >
            {canEdit
                ?
                <FieldTimeReportIsBillable_Editable
                    field       = {props.field}
                    model       = {timeReport}
                    onChange    = {onChange}
                />
                :
                <div className="ui5-field-editable w-100-percent h-100-percent size-small">
                    <div className={Classes("ui5-toggle-button size-22", {
                        "selected": timeReport.isBillable
                    })}>
                        <div className={Classes("icon", timeReport.isBillable ? "i5-cash" : "i5-no-cash")}/>
                    </div>
                </div>
            }
        </div>
    )
}
